import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-attractions',
  templateUrl: './attractions.component.html',
  styleUrls: ['./attractions.component.scss']
})
export class AttractionsComponent implements OnInit {

  skiLifts = [
    {
      name: 'Kotelnica Białczańska',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588242054/kwateryujac/kotelnica_voq0he.jpg',
      description: 'Kotelnica Białczańska to jeden z największych ośrodków narciarskich w Polsce. Dojazd do górnej stacji zajmuje ok. 5 minut',
      page: 'https://bialkatatrzanska.pl'
    },
    {
      name: 'Rusin-Ski',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588242058/kwateryujac/rusinski_hly2is.jpg',
      description: 'Stacja narciarska Rusin-Ski znajdująca sie na wierchu rusińskim. Dojazd od nas również zajmuje ok. 5 minut.',
      page: 'https://rusin-ski.pl/'
    },
    {
      name: 'Bachledova dolina',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588242059/kwateryujac/bachledka_z0yb73.jpg',
      description: 'Bachledova dolina na Słowacji, tuż przy granicy z Polską. Miejsce które warto zobaczyć nie tylko zimą.',
      page: 'https://bachledka.sk/pl'
    },
    {
      name: 'JurgówSki',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588242054/kwateryujac/hawran_z4i036.jpg',
      description: 'Stacja narciarska JurgówSki w Jurgowie. Idealnie miejsce na narty połączone z pięknymi widokami',
      page: 'http://www.jurgowski.pl/'
    },
    {
      name: 'GrapaSki',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588242057/kwateryujac/grapaski_kzcgmz.jpg',
      description: 'Kompleks narciarski GrapaSki położony jest w miejscowści Czarna Góra.',
      page: 'https://www.grapa.ski/zima/'
    },
    {
      name: 'Koziniec-Ski',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588242057/kwateryujac/koziniec_nuhhwy.jpg',
      description: 'Ośrodek narciarski Koziniec w Czarnej Górze. Doskonale widoczny z naszego okna.',
      page: 'http://www.koziniec-ski.pl/'
    },
    {
      name: 'Harenda',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588242054/kwateryujac/harenda_oqee30.jpg',
      description: 'Ośrodek Narciarsko Rekreacyjny Harenda w Zakopanem.',
      page: 'http://www.harendazakopane.pl/'
    },
    {
      name: 'Olczań-Ski',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588242054/kwateryujac/olczanski_niadvz.jpg',
      description: 'Kompleks wyciągów OlczańSki na wierchu olczańskim. Dojazd od nas wynosi ok. 5 minut.',
      page: 'http://www.olczan-ski.pl/'
    },
  ]

  pools = [
    {
      name: 'Termy Bukowina',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588242782/kwateryujac/bukowina_yumuf3.jpg',
      description: 'Termy Bukowina to idealne miejsce na relaks.',
      page: 'https://www.termybukovina.pl/'
    },
    {
      name: 'Terma Bania',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588243014/kwateryujac/bania_az5fch.jpg',
      description: 'Terma Bania to nowoczesny park wodny. ',
      page: 'https://www.termabania.pl/'
    },
    {
      name: 'Gorący Potok',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588243431/kwateryujac/goracypotok_a3dtli.jpg',
      description: 'Gorący Potok w Szaflarach. Doskonałe miejsce do zabawy połączonej z relaksem.',
      page: 'https://www.goracypotok.pl/'
    },
    {
      name: 'Chochołowskie Termy',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588243252/kwateryujac/chocholow_rut4ze.jpg',
      description: 'Chochołowskie Termy, miejsce pełne atrakcji dla dzieci i dorosłych.',
      page: 'https://www.chocholowskietermy.pl/'
    }
]

mountains = [
  {
      name: 'Morskie Oko',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588245115/kwateryujac/morskie-oko_ad30qx.jpg',
      description: 'Największe jezioro w tatrach. Warte zobaczenia.',
      page: 'https://schroniskomorskieoko.pl/pl'
  },
  {
      name: 'Dolina Pięciu Stawów',
      photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588245750/kwateryujac/5-Staw%C3%B3w-34_yfczbw.jpg',
      description: 'Jedna z najpiękniejszych dolin w tatrach.',
      page: 'https://piecstawow.pl/'
  },
  {
    name: 'Wiktorówki',
    photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588245751/kwateryujac/sanktuarium-na-wiktorowkach_toga8f.jpg',
    description: 'Sanktuarium Maryjne na Wiktorówkach. Warte odwiedzenia.',
    page: 'https://wiktorowki.dominikanie.pl/'
  },
  {
    name: 'Kasprowy Wierch',
    photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588245750/kwateryujac/20160722-ab-dsc07384-copy_krvass.jpg',
    description: 'Kasprowy Wierch to szczyt w Tatrach na który można łatwo dostać się kolejką.',
    page: 'https://www.kasprowywierch.biz/'
  },
  {
    name: 'Giewont',
    photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588245748/kwateryujac/giewont_eqbgkw.jpg',
    description: 'Giewont to jeden z najpopularniejszych i najbardziej rozpoznwalnych szczytów w Polsce. ',
    page: 'http://i-tatry.pl/giewont/'
  },
  {
    name: 'Dolina Chochołowska',
    photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588245748/kwateryujac/dolina-chocholowska_f6pdb7.jpg',
    description: 'Dolina Chochołowska cięszy się największym zainteresowaniem wiosną, kiedy kwitną krokusy.',
    page: 'http://chocholowska.com/'
  },
  {
    name: 'Siklawa',
    photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588245747/kwateryujac/siklawa-w-tatrach-225113_ioi4my.jpg',
    description: 'Wielka Siklawa jest największym wodospadem w Polsce. Znajduje się on na potoku Roztoka w Tatrach.',
    page: 'http://i-tatry.pl/wodospad-siklawa/'
  },
  {
    name: 'Gubałówka',
    photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588245748/kwateryujac/gubalowka_kjcems.jpg',
    description: 'Gubałówka w Zakopanem to wspaniały punkt widokowy na Tatry oraz Podhale.',
    page: 'https://www.pkl.pl/gubalowka/gubalowka.html'
  }
]

others = [
  {
    name: 'Rowerem wokół tatr',
    photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588246345/kwateryujac/wkoltatr_dv9hk4.jpg',
    description: 'Scieżka rowerowa wokół tatr jest idealnym wyborem na aktywne spędzenie czasu, w połączeniu z piękną otaczającą scenerią.',
    page: 'http://www.szlakwokoltatr.eu/'
  },
  {
    name: 'Wielka Krokiew',
    photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588246346/kwateryujac/skocznia-zakopane-zima_e2gih4.jpg',
    description: 'Skocznia narciarska im. Stanisława Marusarza to również obiekt warty zainteresowania.',
    page: 'https://zakopane.cos.pl/375/wielka-krokiew'
  },
  {
    name: 'Koronami drzew',
    photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588246345/kwateryujac/korunamistromov_dll812.jpg',
    description: 'Chodnik koronami drzew znajduje się w Bachledovej Dolinie na Słowacji, tuż przy granicy z Polską.',
    page: 'https://chodnikkorunamistromov.sk/pl/'
  },
  {
    name: 'Zamek w Niedzicy',
    photoUrl: 'https://res.cloudinary.com/ddzb7kwan/image/upload/v1588246346/kwateryujac/zamek-w-niedzicy_znamq7.jpg',
    description: 'Średniowieczny zamek Dunajec, który znajduje się w Pieninach nad jeziorem Czorsztyńskim',
    page: 'http://www.zamek-w-niedzicy.pl/'
  }
]

  constructor() { }
  
  ngOnInit() {
  }


}
